
import React from 'react';
import { Link } from 'react-router-dom';
import { AnimatedSection } from '@/hooks/useScrollAnimation';
const imgJornada = '/jornada-paciente-cirurgia-plastica.webp';

interface JourneySectionProps {
  overrideTitle?: React.ReactNode;
  overrideDescription?: string;
  overrideCta?: string;
}

const JourneySection: React.FC<JourneySectionProps> = ({
  overrideTitle,
  overrideDescription,
  overrideCta,
} = {}) => {
  const title = overrideTitle ?? (
    <>Sua jornada <span className="text-gradient">comigo</span></>
  );
  const description = overrideDescription ??
    'Desde a primeira consulta, avalio suas expectativas e explico com clareza o que é possível alcançar. Acompanho cada etapa do processo, garantindo segurança e orientação durante toda a recuperação.';
  const cta = overrideCta ?? 'Conheça sua jornada';

  return (
    <section id="jornada" aria-labelledby="journey-title" className="relative overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0" aria-hidden="true">
        <img
          src={imgJornada}
          alt=""
          aria-hidden="true"
          title="Jornada do paciente em cirurgia plástica com Dr. Luis Brunello"
          className="w-full h-full object-cover"
          loading="lazy"
          decoding="async"
          width="1920"
          height="960"
        />
        <div className="absolute inset-0 bg-dark-base/80" />
        <div className="absolute inset-0 bg-gradient-to-r from-dark-base/90 via-dark-base/60 to-dark-base/30" />
      </div>

      <div className="relative z-10 container mx-auto px-6 lg:px-12 py-20 md:py-28">
        <AnimatedSection>
          <header className="text-center max-w-2xl mx-auto">
            <p className="subtitle-wide text-gold mb-4 block">Processo</p>
            <h2 id="journey-title" className="text-3xl md:text-4xl lg:text-5xl text-light-primary leading-tight tracking-tight mb-6">
              {title}
            </h2>
            <p className="text-light-muted text-base md:text-lg leading-relaxed mb-8">
              {description}
            </p>
            <Link
              to="/jornada"
              className="btn-pill btn-gold inline-flex items-center gap-2 text-sm font-semibold px-6 py-3"
            >
              {cta}
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </Link>
          </header>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default JourneySection;
